/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import Chart from 'react-google-charts';
import { ReactGoogleChartProps } from 'react-google-charts/dist/types';
import { DataOrNotWrapper } from './DataOrNotWrapper';
import { QuestionReferenceProps } from '../QuestionReference';

type GoogleChartProps = ReactGoogleChartProps & QuestionReferenceProps;

const ChartOrNotWrapper = (props: GoogleChartProps) => {
  return (
    <DataOrNotWrapper {...props}>
      <Chart {...props} />
    </DataOrNotWrapper>
  );
}

export default ChartOrNotWrapper;
